module.exports = __webpack_public_path__ + "8a5356e9/img/question-icon.06c20c5d.svg";